/* eslint-env browser */

'use strict';

/*eslint-disable-next-line no-undef */
__webpack_public_path__ = assetsUrl;

module.exports = payload => {
  const modulePromises = [];

  if (
    payload.loadSwitch &&
    payload.loadSwitch.shouldLoadDealWidgets &&
    payload.clientDealWidgets
  ) {
    modulePromises.push(
      import(/* webpackChunkName: "widgets" */ './loaders/widgets')
    );
  }

  if (payload.sharing) {
    modulePromises.push(
      import(/* webpackChunkName: "facebook" */ './loaders/facebook')
    );
  }

  return modulePromises;
};
